import React from 'react';
import PhaseSetup from './PhaseSetup';
import Phase1Swiss from './Phase1Swiss';
import PhaseTiebreaker from './PhaseTiebreaker';
import Phase2Bracket from './Phase2Bracket';
import Phase3Results from './Phase3Results';

export default function TournamentManager({ tournament, tournaments, role, user }) {
    if (tournament.phase === 'setup') return <PhaseSetup tournament={tournament} tournaments={tournaments} role={role} user={user} />;
    if (tournament.phase === 'phase1') return <Phase1Swiss tournament={tournament} role={role} />;
    if (tournament.phase === 'phase_tiebreaker') return <PhaseTiebreaker tournament={tournament} role={role} />;
    if (tournament.phase === 'phase2') return <Phase2Bracket tournament={tournament} role={role} />;
    if (tournament.phase === 'completed') return <Phase3Results tournament={tournament} role={role} />;
    return null;
}